import { forwardRef } from 'react';
import { theme } from '@frontend/theme';
import { floatingStyles } from './floating-styles';

type Props = {
  children?: React.ReactNode;
  onClick?: () => void;
};

export const FloatingTool = forwardRef<HTMLDivElement, Props>(({ children, onClick, ...rest }, ref) => {
  return (
    <div
      css={[
        floatingStyles,
        {
          background: theme.colors.white,
          border: `solid 1px ${theme.colors.neutral20}`,
          color: theme.colors.neutral70,
          '&:focus-within': {
            borderColor: theme.colors.primary50,
          },
          '.floating-toolbar.right-top &, .floating-toolbar.right-center &, .floating-toolbar.right-bottom &': {
            borderLeft: 0,
          },
          '.floating-toolbar.left-top &, .floating-toolbar.left-center &, .floating-toolbar.left-bottom &': {
            borderRight: 0,
          },
        },
      ]}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
      ref={ref}
      {...rest}
    >
      {children}
    </div>
  );
});

FloatingTool.displayName = 'FloatingTool';
